import { Typography, Box, Button } from '@mui/material';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { EventsList } from '../components/EventsList';

export function EventsPage() {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <PageHeader currentPath="/events">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <AirlineStopsIcon sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h5" component="h1" fontWeight={600}>
                        Events
                    </Typography>
                </Box>
                <Button variant="outlined" startIcon={<RefreshIcon />} onClick={handleRefresh}>
                    Refresh
                </Button>
            </Box>

            <EventsList refreshTrigger={refreshTrigger} />
        </PageHeader>
    );
}
